import { render, staticRenderFns } from "./StTeaserPressReleasesHome.vue?vue&type=template&id=9657c84a"
import script from "./StTeaserPressReleasesHome.vue?vue&type=script&lang=ts"
export * from "./StTeaserPressReleasesHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports